import React from "react";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import Select from "react-select";
// import { CustomSelectStyles } from "../../../../components/CustomTable";
import { useNavigate } from "react-router-dom";
// import moment from "moment";

import { Country, createupdateForm, createupdateResopnsePayload } from "../../../../model/clientmodel";
import { useManageClientContext } from "../../../../context/ManageClientContex";
import CustomDatePicker from "../../../../components/CustomDatePicker";
import { CustomSelectStyles } from "../../../../components/CustomTable";
import ReusableSearchInput from "../../../../components/ReusableSearchInput";
import { getUserIdTokenForIonTime } from "../../../../helper/api";
import moment from "moment";

const defaultValue: createupdateForm = {
  report_intervals_id: 1,
  title: "",
  start_date: null,
  address: "",
  location_id: { value: 0, label: "" },
  p_location: "",
  contact_name: "",
  phone: "",
  email: "",
  passwd: "",
  sales_contact_name: "",
  sales_contact_no: "",
  project_or_account_manager_name: "",
  sales_contact_email: "",
};

enum ValidationPatterns {
  Email = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
  Phone = "^[0-9]{10,12}$",
}

enum ValidationMessages {
  Required = "This field is required",
  InvalidEmail = "Invalid email address",
  InvalidPhone = "Invalid phone number. It should contain only digits and be between 10 to 12 characters long.",
}

const ClientForm: React.FC = () => {
  const navigate = useNavigate();
  const getUserId = getUserIdTokenForIonTime();
  const { addandupdateClient, clientDetails, clientId, clientFormType, clientPageOption } =
    useManageClientContext();

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<createupdateForm>({ mode: "all", defaultValues: defaultValue });

  React.useEffect(() => {
    reset(defaultValue);
    if (clientId && clientDetails && clientFormType === "update") {
      const clientDetail = clientDetails.client_details;
      setValue("title", clientDetail["client name"]);
      setValue(
        "start_date",
        moment(clientDetail["engagement start date"]).isValid()
          ? moment(clientDetail["engagement start date"]).toDate()
          : null,
      );
      setValue("address", clientDetail.address);
      setValue("report_intervals_id", clientDetail["report interval id"]);
      setValue("location_id", { value: clientDetail["country id"], label: clientDetail.country });
      setValue("p_location", clientDetail["project location"]);
      setValue("contact_name", clientDetail["client contact name"]);
      setValue("phone", clientDetail["client contact number"]);
      setValue("email", clientDetail["client contact email"]);
      setValue("sales_contact_name", clientDetail["sales contact name"]);
      setValue("sales_contact_no", clientDetail["sales contact number"]);
      setValue("project_or_account_manager_name", clientDetail["account manager"]);
      setValue("sales_contact_email", clientDetail["sales contact email"]);
    }
  }, [clientId, clientFormType, reset, clientDetails, setValue]);

  const onSubmit: SubmitHandler<createupdateForm> = async (data) => {
    const clientDetail = clientDetails && clientDetails.client_details;
    const projectPayload: createupdateResopnsePayload = {
      user_id: Number(getUserId),
      client_id: clientFormType === "create" ? null : clientId,
      client: {
        id: clientFormType === "create" ? null : clientDetail?.id,
        is_active: true,
        start_date: moment(data.start_date).isValid() ? moment(data.start_date).format("DD/MM/YYYY") : null,
        report_intervals_id: data.report_intervals_id,
        title: data.title,
        is_enabled: true,
        create_ts: null,
        modify_ts: null,
        address: data.address,
        location_id: Number(data.location_id?.value),
        p_location: data.p_location,
      },
      clientContact: {
        id: clientFormType === "create" ? null : clientDetail?.["client contact id"],
        clients_id: clientFormType === "create" ? null : clientId,
        contact_name: data.contact_name,
        phone: data.phone,
        email: data.email,
        passwd: "",
        is_enabled: true,
        create_ts: null,
        modify_ts: null,
      },
      salesContact: {
        id: clientFormType === "create" ? null : clientDetail?.["sales contact id"],
        clients_id: clientFormType === "create" ? null : clientId,
        sales_contact_name: data.sales_contact_name,
        sales_contact_no: data.sales_contact_no,
        project_or_account_manager_name: data.project_or_account_manager_name,
        is_enabled: true,
        create_ts: null,
        modify_ts: null,
        sales_contact_email: data.sales_contact_email,
      },
    };
    await addandupdateClient(projectPayload);

    return;
  };

  return (
    <form
      className='max-w-4xl grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 '
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className='mb-2 col-span-full'>
        <h5 className='block mb-2 text-lg font-bold text-gray-900 dark:text-white'>General Information</h5>
      </div>
      <div className='mb-2'>
        <label htmlFor='projectName' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Client Name <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='title'
          control={control}
          rules={{ required: "Client Name is required" }}
          render={({ field }) => (
            <input
              {...field}
              type='text'
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          )}
        />
        {errors.title && <p className='text-red-500 text-sm mt-1'>{errors.title.message}</p>}
      </div>

      <div className='mb-2'>
        <label htmlFor='startDate' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Start Date <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='start_date'
          control={control}
          rules={{ required: "Start Date is required" }}
          render={({ field }) => (
            <CustomDatePicker
              onChange={field.onChange}
              selectedDate={field.value}
              isClearable={false}
              dateFormat='dd/MM/yyyy'
            />
          )}
        />
        {errors.start_date && <p className='text-red-500 text-sm mt-1'>{errors.start_date.message}</p>}
      </div>

      <div className='mb-2 col-span-full'>
        <label htmlFor='manager' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Address
        </label>
        <Controller
          name='address'
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              value={field.value}
              rows={2}
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          )}
        />
        {errors.address && <p className='text-red-500 text-sm mt-1'>{errors.address.message}</p>}
      </div>

      <div className='mb-2'>
        <label htmlFor='altManager' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Country <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='location_id'
          control={control}
          rules={{ required: "Country is required" }}
          render={({ field }) => (
            <Select
              className='basic-single'
              onChange={field.onChange}
              isSearchable
              name={field.name}
              options={clientPageOption?.["countries"].map((item: Country) => ({
                value: item.id,
                label: item.location,
              }))}
              value={field.value}
              styles={CustomSelectStyles}
            />
          )}
        />
        {errors.location_id && <p className='text-red-500 text-sm mt-1'>{errors.location_id.message}</p>}
      </div>

      <div className='mb-2'>
        <label htmlFor='status' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Report Interval <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='report_intervals_id'
          control={control}
          rules={{ required: "Report Interval is required" }}
          render={({ field }) => (
            <select
              value={field.value.toString()}
              onChange={(e) => field.onChange(Number(e.target.value))}
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            >
              <option selected>Select</option>
              {clientPageOption?.["report-interval"].map((item) => (
                <option key={item.id} value={item.id}>
                  {item?.display}
                </option>
              ))}
            </select>
          )}
        />
        {errors.report_intervals_id && (
          <p className='text-red-500 text-sm mt-1'>{errors.report_intervals_id.message}</p>
        )}
      </div>
      <hr className='h-px my-4 bg-gray-200 border-0 dark:bg-gray-700 col-span-full'></hr>
      <div className='mb-2 col-span-full'>
        <h5 className='block mb-2 text-lg font-bold text-gray-900 dark:text-white'>
          Client Contact Information
        </h5>
      </div>

      <div className='mb-2'>
        <label htmlFor='billing' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Name <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='contact_name'
          control={control}
          rules={{ required: "Name is required" }}
          render={({ field }) => (
            <input
              {...field}
              type='text'
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          )}
        />
        {errors.contact_name && <p className='text-red-500 text-sm mt-1'>{errors.contact_name.message}</p>}
      </div>

      <div className='mb-2'>
        <label htmlFor='status' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Contact Number
        </label>
        <Controller
          name='phone'
          control={control}
          rules={{
            pattern: {
              value: new RegExp(ValidationPatterns.Phone),
              message: ValidationMessages.InvalidPhone,
            },
          }}
          render={({ field }) => (
            <input
              {...field}
              minLength={0}
              maxLength={12}
              type='text'
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          )}
        />
        {errors.phone && <p className='text-red-500 text-sm mt-1'>{errors.phone.message}</p>}
      </div>

      <div className='mb-2'>
        <label htmlFor='department' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Email
        </label>
        <Controller
          name='email'
          control={control}
          rules={{
            pattern: {
              value: new RegExp(ValidationPatterns.Email),
              message: ValidationMessages.InvalidEmail,
            },
          }}
          render={({ field }) => (
            <input
              {...field}
              type='email'
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          )}
        />
        {errors.email && <p className='text-red-500 text-sm mt-1'>{errors.email.message}</p>}
      </div>
      <hr className='h-px my-4 bg-gray-200 border-0 dark:bg-gray-700 col-span-full'></hr>
      <div className='mb-2 col-span-full'>
        <h5 className='block mb-2 text-lg font-bold text-gray-900 dark:text-white'>
          Ionidea Sales Contact Information
        </h5>
      </div>

      <div className='mb-2'>
        <label htmlFor='billing' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Name <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='sales_contact_name'
          control={control}
          rules={{ required: "Name is required" }}
          render={({ field }) => (
            <input
              {...field}
              type='text'
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          )}
        />
        {errors.sales_contact_name && (
          <p className='text-red-500 text-sm mt-1'>{errors.sales_contact_name.message}</p>
        )}
      </div>

      <div className='mb-2'>
        <label htmlFor='status' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Contact Number
        </label>
        <Controller
          name='sales_contact_no'
          control={control}
          rules={{
            pattern: {
              value: new RegExp(ValidationPatterns.Phone),
              message: ValidationMessages.InvalidPhone,
            },
          }}
          render={({ field }) => (
            <input
              {...field}
              minLength={0}
              maxLength={12}
              type='text'
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          )}
        />
        {errors.sales_contact_no && (
          <p className='text-red-500 text-sm mt-1'>{errors.sales_contact_no.message}</p>
        )}
      </div>

      <div className='mb-2'>
        <label htmlFor='department' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Email
        </label>
        <Controller
          name='sales_contact_email'
          control={control}
          rules={{
            pattern: {
              value: new RegExp(ValidationPatterns.Email),
              message: ValidationMessages.InvalidEmail,
            },
          }}
          render={({ field }) => (
            <input
              {...field}
              type='email'
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          )}
        />
        {errors.sales_contact_email && (
          <p className='text-red-500 text-sm mt-1'>{errors.sales_contact_email.message}</p>
        )}
      </div>
      <div className='mb-2'>
        <label htmlFor='status' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Project Location <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='p_location'
          control={control}
          rules={{ required: "Project Location is required" }}
          render={({ field }) => (
            <select
              value={field.value}
              onChange={(e) => field.onChange(e.target.value)}
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            >
              <option selected>Select</option>
              {clientPageOption?.["project-locations"].map((item) => (
                <option key={item.country} value={item.country}>
                  {item.country}
                </option>
              ))}
            </select>
          )}
        />
        {errors.p_location && <p className='text-red-500 text-sm mt-1'>{errors.p_location.message}</p>}
      </div>
      <div className='mb-2 col-span-2'>
        <label htmlFor='status' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Project Manager / Account Manager(Names are from LDAP)<span className='text-red-400'>*</span>
        </label>
        <Controller
          name='project_or_account_manager_name'
          control={control}
          rules={{ required: "Manager name is required" }}
          render={({ field }) => (
            <ReusableSearchInput
              value={field.value ?? ""}
              onChange={field.onChange}
              setOptionsData={(item) => setValue("project_or_account_manager_name", item?.ldap_uid ?? "")}
            />
          )}
        />
        {errors.project_or_account_manager_name && (
          <p className='text-red-500 text-sm mt-1'>{errors.project_or_account_manager_name.message}</p>
        )}
      </div>

      <div className='max-w-4xl col-span-full'>
        <button
          type='submit'
          className='text-white bg-blue-700 mr-2 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
        >
          Save
        </button>
        <button
          type='button'
          onClick={() => navigate(-1)}
          className='text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800'
        >
          Close
        </button>
      </div>
    </form>
  );
};

export default ClientForm;
